import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcFileInvoiceDollar, IcReceipt, IcSave } from "../../Icons";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function CargosCreate() {
  const { user }       = useContext(AuthContext);
  const URL_LOGS       = process.env.REACT_APP_URL_LOGS;
  const URL_CARGOS     = process.env.REACT_APP_URL_CARGOS;
  const URL_CLIENTES   = process.env.REACT_APP_URL_CLIENTES;

  const [clientes,        setClientes]        = useState([]);
  const [value,           setValue]           = useState("");
  const [fecha,           setFecha]           = useState("");
  const [importe,         setImporte]         = useState("");
  const [descripcion,     setDescripcion]     = useState("");
  const [categoria,       setCategoria]       = useState("Otros");
  const [validaBoton,     setValidaBoton]     = useState(true);

  const clear = () => {
    setValue("");
    setFecha("");
    setImporte("");
    setDescripcion("");
    setCategoria("Otros");
    setValidaBoton(true);
  };

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setClientes(res.data))
      .catch(() => {});
  }, []);

  const saveCargo = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios.post(
        URL_CARGOS,
        {
          mensualidad: "No",
          fecha,
          descripcion,
          importe,
          categoria,
          clientes: value._id,
          abonos: 0,
          saldo: importe,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      axios.post(
        URL_LOGS,
        { tipo: "Cargo", detalle: `${value._id}`, user: user.id },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      clear();
      Swal.fire("¡Listo!", "Cargo registrado con éxito", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch {
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      setValidaBoton(true);
    }
  };

  const options = clientes.map((c) => ({
    firstLetter: /[0-9]/.test(c.nombre_comercial[0].toUpperCase()) ? "0-9" : c.nombre_comercial[0].toUpperCase(),
    ...c,
    junta: c.nombre_comercial,
  }));

  return (
    <>
      <Header />
      <br />
      {user.usuarios_permisos ? (
        <div className="card container col-sm-9">

          {/* ── Page header ────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcFileInvoiceDollar style={{ marginRight: 8, color: "#3b82f6" }} />
                Nuevo Cargo
              </h3>
              <p className="page-subtitle">Registra un cargo a la cuenta de un cliente</p>
            </div>
          </div>

          <Form onSubmit={saveCargo}>

            {/* ── Sección: Información del Cargo ───────────────────────── */}
            <div className="form-section">
              <div className="form-section-header">
                <IcReceipt />
                <span className="form-section-title">Información del Cargo</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Cliente</Label>
                      <Autocomplete
                        size="small"
                        value={value}
                        onChange={(_, sel) => sel && setValue(sel)}
                        options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                        groupBy={(o) => o.firstLetter}
                        getOptionLabel={(o) => o.junta || ""}
                        renderInput={(params) => (
                          <TextField {...params} label="Selecciona" variant="outlined" required />
                        )}
                        renderOption={(o) => (
                          <React.Fragment>{o.nombre_comercial}</React.Fragment>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Fecha</Label>
                      <Input
                        type="date"
                        value={fecha}
                        required
                        onChange={(e) => setFecha(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Importe</Label>
                      <Input
                        type="number"
                        placeholder="0.00"
                        value={importe}
                        required
                        onChange={(e) => setImporte(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <FormGroup>
                      <Label>Descripción</Label>
                      <Input
                        type="text"
                        placeholder="Descripción del cargo"
                        value={descripcion}
                        required
                        onChange={(e) => setDescripcion(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Categoría</Label>
                      <Input
                        type="select"
                        value={categoria}
                        required
                        onChange={(e) => setCategoria(e.target.value)}
                      >
                        <option value="Mensualidad">Mensualidad</option>
                        <option value="Setup">Setup</option>
                        <option value="Complemento">Complemento</option>
                        <option value="Otros">Otros</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>

            {/* ── Submit ──────────────────────────────────────────────── */}
            <div className="submit-bar">
              <Button type="submit" color="success" disabled={!validaBoton}>
                <IcSave style={{ marginRight: 6 }} />
                Registrar Cargo
              </Button>
            </div>

          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default CargosCreate;
